import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Clear any legacy localStorage tokens
    localStorage.removeItem('sims_token');
    localStorage.removeItem('sims_user');

    const stored = sessionStorage.getItem('sims_user');
    const token  = sessionStorage.getItem('sims_token');
    if (stored && token) {
      try { setUser(JSON.parse(stored)); } catch {}
    }
    setLoading(false);
  }, []);

  const login = async (username, password) => {
    const res = await authAPI.login({ username, password });
    const { token, ...userData } = res.data.data;

    // Clear legacy localStorage
    localStorage.removeItem('sims_token');
    localStorage.removeItem('sims_user');

    sessionStorage.setItem('sims_token', token);
    sessionStorage.setItem('sims_user', JSON.stringify(userData));
    setUser(userData);
    return userData;
  };

  const logout = () => {
    sessionStorage.removeItem('sims_token');
    sessionStorage.removeItem('sims_user');
    localStorage.removeItem('sims_token');
    localStorage.removeItem('sims_user');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
